export default __webpack_public_path__ + "static/Deirdra-Colvin-becf305cfbfdd0d7525947cc4f248dfa.jpeg";